module.exports = __webpack_public_path__ + "static/img/fish15.633eaf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/jiejifish/fish15.png
// module id = MciH
// module chunks = 0